import { updateFilters, setEnabledFilters } from 'reducers/filters';
import { initialiseSortOrder } from 'reducers/listingsSortOrder';
import {
    updateTotalResults,
    updatePageNumber,
    updateTotalResultsWasLimited,
    updatePolyenc
} from 'reducers/searchResults';
import { initialiseReduxFilters } from 'search/helpers';

import searchTranslations from 'public/locales/en/search.json';
import { getTranslator } from 'shared/i18n/getTranslator';
import { Store } from 'redux';
import { ParsedUrlQuery } from 'querystring';
import { RawSortOrderOption } from 'reducers/listingsSortOrder.types';
import { RawFilter } from 'reducers/filters.types';

type DispatchData = {
    sortOrder: {
        currentSortOrder: string;
        options: RawSortOrderOption[];
    };
    totalResults: number;
    pageNumber: number;
    totalResultsWasLimited: boolean;
    polyenc: string | null;
    filtersFields: RawFilter[];
};

const t = getTranslator(searchTranslations);

export const dispatchData = (
    store: Store,
    data: DispatchData,
    query: ParsedUrlQuery
) => {
    const {
        sortOrder,
        totalResults,
        pageNumber,
        totalResultsWasLimited,
        polyenc,
        filtersFields
    } = data;

    store.dispatch(initialiseSortOrder(t, sortOrder));
    store.dispatch(updateTotalResults(totalResults));
    store.dispatch(updatePageNumber(pageNumber));
    store.dispatch(updateTotalResultsWasLimited(totalResultsWasLimited));
    store.dispatch(updatePolyenc(polyenc));

    const filtersFormatted = initialiseReduxFilters(filtersFields, query);

    store.dispatch(updateFilters(filtersFormatted));
    store.dispatch(setEnabledFilters());
};
